import {Model} from './Model';
import {VisitorSurvey} from './VisitorSurvey';
import {SessionStorageObject} from '../Utilities/SessionStorageObject';
import {RedeemType} from './RedeemType';

export class Event extends Model implements SessionStorageObject {
  public clientId: number = 0;
  public eventId: number = 0;
  public eventSeriesId: number = 0;
  public descriptionExternal: string = '';
  public shortDescription: string = '';
  public subtitle: string = '';
  public logo: Array<any> = [];
  public color: Array<any> = [];
  public eventDateStart: string = '';
  public eventDateEnd: string = '';
  public publicationDateStart: string = '';
  public publicationDateEnd: string = '';
  public locationId: string = '';
  public eventType: number = 0;
  public openingHours: any = '';
  public linkIndexExhibitors: string = '';
  public linkWWWGuestOrganizer: string = '';
  public activeLocalSalePlatform: string = '';
  public visitorSurvey: VisitorSurvey | null = null;
  public halls: string = '';
  public paymentMethods: Array<never> = [];
  public redeemTypes: Array<RedeemType> = [];
  public useFilterInTicketlist: boolean = false;
  public provideDownloadLink: boolean = false;

  public translations: Array<any> = [];

  constructor(data: any) {
    super(data);
    this.clientId = data.clientId;
    this.eventId = data.eventId;
    this.eventSeriesId = data.eventSeriesId;
    this.descriptionExternal = data.descriptionExternal;
    this.shortDescription = data.shortDescription;
    this.subtitle = data.subtitle;
    this.logo = data.logo;
    this.color = data.color;
    this.eventDateStart = data.eventDateStart;
    this.eventDateEnd = data.eventDateEnd;
    this.publicationDateStart = data.publicationDateStart;
    this.publicationDateEnd = data.publicationDateEnd;
    this.locationId = data.locationId;
    this.eventType = data.eventType;
    this.openingHours = data.openingHours;
    this.linkIndexExhibitors = data.linkIndexExhibitors;
    this.linkWWWGuestOrganizer = data.linkWWWGuestOrganizer;
    this.activeLocalSalePlatform = data.activeLocalSalePlatform;
    this.visitorSurvey = (Array.isArray(data.visitorSurvey) && data.visitorSurvey.length > 0) ? new VisitorSurvey(data.visitorSurvey) : null;
    this.redeemTypes = (Array.isArray(data.redeemTypes) && data.redeemTypes.length > 0) ? data.redeemTypes.map(rt => new RedeemType(rt)) : [];
    this.halls = data.halls;
    this.translations = data.translations;
    this.paymentMethods = data.paymentMethods;
    this.useFilterInTicketlist = data.useFilterInTicketlist;
    this.provideDownloadLink = data.provideDownloadLink;
  }

  fromStorage(data: any) {
    return new Event(data);
  }

  toString(): string {
    return `${this.descriptionExternal}`;
  }
}
